import {Injectable} from '@angular/core';
import {catchError, finalize, map, Observable, of, retry, throwError, timeout, TimeoutError} from 'rxjs';
import { Jumpbox, JumpboxResponse } from 'src/app/models/tenant/jumpbox';
import {FabricService} from 'src/app/services/fabric/fabric.service';
import { CustomToastrService } from '../util/toastr.service';
import { translate } from '@jsverse/transloco';

const SERVICE_NAME = 'mgmt-jumpbox-resources';


@Injectable({
  providedIn: 'root'
})
export class JumpboxService {

  constructor(private fabricService: FabricService, private toastrService: CustomToastrService) {}

  getJumpboxes(tenantId?: string): Observable<JumpboxResponse | Jumpbox[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_jumpboxes', {tenantId});
  }

  private isValidJumpboxRecord(record: unknown): record is Jumpbox {
    return (
      record !== null &&
      typeof record === 'object' &&
      'status' in record &&
      'expiresAt' in record &&
      typeof (record as Jumpbox).status === 'string' &&
      typeof (record as Jumpbox).expiresAt === 'string'
    );
  }

  private getErrorMessage(error: unknown): string {
    if (error instanceof TimeoutError) {
      return 'Request timed out. Please try again.';
    }

    if (error instanceof Error) {
      return error.message;
    }

    return 'An unexpected error occurred';
  }

  createJumpboxes(obj?): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_tenants_tenantid_jumpboxes', obj);
  }

  updateJumpboxes(obj?): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_jumpboxes_id_extend', obj);
  }

  deleteJumpboxes(tenantId, id): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_tenants_tenantid_jumpboxes_id', {tenantId, id});
  }

}
